import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CouponAttributes, DiscountType } from "@models/coupon.model";
import { TableDataResponse } from "@models/data-grid.model";
import { Observable } from "rxjs";
import { environment } from "~/src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class CouponService {
    constructor(private readonly http: HttpClient) {}

    public getCoupons(
        pageIndex: number = environment.dynamicPagination.pageIndex,
        pageSize: number = environment.dynamicPagination.pageSize,
        couponCode?: string,
    ): Observable<TableDataResponse> {
        let url = "";
        if (couponCode) {
            const encodedCouponCode = encodeURIComponent(couponCode);
            url = `${environment.apiUrlBasePath}/admin/getCoupons?pageIndex=${pageIndex}&pageSize=${pageSize}&couponCode=${encodedCouponCode}`;
        } else {
            url = `${environment.apiUrlBasePath}/admin/getCoupons?pageIndex=${pageIndex}&pageSize=${pageSize}`;
        }
        return this.http.get<TableDataResponse>(url);
    }

    public updateCouponStatus(params: { id: number; status: boolean }): Observable<string> {
        return this.http.put<string>(`${environment.apiUrlBasePath}/admin/updateCouponStatus`, params);
    }

    // public getAllActiveCoupon(): Observable<CouponAttributes[]> {
    //     return this.http.get<CouponAttributes[]>(`${environment.apiUrlBasePath}/admin/getAllActiveCoupon`);
    // }

    // public updateCouponOnProducts(activeCouponIds: number[], productIds: number[]): Observable<string> {
    //     const params = { activeCouponIds, productIds };
    //     return this.http.put<string>(`${environment.apiUrlBasePath}/admin/updateCouponOnProducts`, params);
    // }

    // public getAvailableCouponDetails(availableCouponCode: object): Observable<CouponAttributes[]> {
    //     const params = { availableCouponCode };
    //     return this.http.post<CouponAttributes[]>(
    //         `${environment.apiUrlBasePath}/products/getAvailableCouponDetails`,
    //         params,
    //     );
    // }

    public checkAndUseCoupon(
        couponCode: string,
        userId: string,
        productIds: number[],
    ): Observable<{
        used: boolean;
        maxAmount: number;
        discountPercentage: number;
        couponCode: string;
        couponId: number;
        discountType: DiscountType[];
    }> {
        return this.http.post<{
            used: boolean;
            maxAmount: number;
            discountPercentage: number;
            couponCode: string;
            couponId: number;
            discountType: DiscountType[];
        }>(`${environment.apiUrlBasePath}/coupons/checkCoupon`, { couponCode, userId, productIds });
    }

    public markCouponAsUsed(
        couponCode: string,
        userId: string,
    ): Observable<{
        used: boolean;
        maxAmount: number;
        discountPercentage: number;
        couponCode: string;
    }> {
        return this.http.post<{
            used: boolean;
            maxAmount: number;
            discountPercentage: number;
            couponCode: string;
        }>(`${environment.apiUrlBasePath}/coupons/markCouponAsUsed`, { couponCode, userId });
    }

    public getUserCoupons(): Observable<CouponAttributes[]> {
        return this.http.get<CouponAttributes[]>(`${environment.apiUrlBasePath}/coupons/getAllCoupons`);
    }

    public getCouponByType(type: string): Observable<CouponAttributes[]> {
        return this.http.get<CouponAttributes[]>(`${environment.apiUrlBasePath}/coupons/couponByType/?type=${type}`);
    }
}
